export default "__VITE_ASSET__D2pN4ycm__"